module.exports = __webpack_public_path__ + "static/media/dishwashers.ff5b46a9.webp";